export default {"src":"/_next/static/media/cross_icon.8e13b173.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};